/**

Adds tab focus to banner buttons and displays details of the selected country
*/
(function initializeBanner() {
  const bannerWrapper = document.querySelector('.our-presence__wrapper');
  if (!bannerWrapper) return;

  const bannerSelect = bannerWrapper.querySelector('#country-select');
  const getCountriesBtn = bannerWrapper.querySelector('.our-presence__submit');
  const bannerButtons = bannerWrapper.querySelectorAll(
    '.our-presence__details a'
  );
  const bannerSubmit = bannerWrapper.querySelector('.our-presence__submit');
  const detailsWrapper = bannerWrapper.querySelector('.our-presence__details');
  const detailsDescription = bannerWrapper.querySelector(
    '.our-presence__details-desc'
  );
  const detailsTitle = bannerWrapper.querySelector(
    '.our-presence__details-title'
  );
  const countryLinkButtons = bannerWrapper.querySelectorAll(
    '.our-presence__details-link'
  );
  const servicesWrapper = bannerWrapper.querySelector(
    '.our-presence__details-services'
  );
  const employerOfRecordNode = servicesWrapper.querySelector(
    '.employer-of-record'
  );
  const payrollNode = servicesWrapper.querySelector('.global-payroll');
  const contractorSolutionsNode = servicesWrapper.querySelector(
    '.independent-contractor-solutions'
  );
  const businessExpansionNode = servicesWrapper.querySelector(
    '.global-business-expansion'
  );
  const visaNode = servicesWrapper.querySelector('.global-visa');
  const PMNode = servicesWrapper.querySelector('.project-management');
  const consultancyNode = servicesWrapper.querySelector(
    '.consultancy-services'
  );
  const vasNode = servicesWrapper.querySelector('.vas');
  const hrConsultancyNode = servicesWrapper.querySelector(
    '.hr-consultancy-services'
  );

  // Set initial details
  setCountryDetails(bannerSelect.selectedOptions[0]);
  /**


  Adds tab focus to banner buttons
  */
  function addTabFocus() {
    if (!bannerButtons.length) return;
    bannerButtons.forEach((btn) => btn.setAttribute('tabIndex', '0'));
  }
  /**

  Displays details of the selected country
  @param {Event} e - The change event
  */
  function displayCountryDetailsOnChange(e) {
    const data = e.target.querySelector('option:checked');
    if (!data) return;
    setCountryDetails(data);
  }

  function setCountryDetails(data) {
    const country = data.value;
    const description = data.getAttribute('data-description');
    const employerOfRecord =
      data.getAttribute('data-employer-of-record') === 'true';
    const payroll = data.getAttribute('data-payroll') === 'true';
    const contractorSolutions =
      data.getAttribute('data-contractor-solutions') === 'true';
    const businessExpansion =
      data.getAttribute('data-business-expansion') === 'true';
    const visa = data.getAttribute('data-visa') === 'true';
    const PM = data.getAttribute('data-pm') === 'true';
    const consultancy = data.getAttribute('data-consultancy') === 'true';
    const vas = data.getAttribute('data-vas') === 'true';
    const hrConsultancy = data.getAttribute('data-hr-consultancy') === 'true';
    const unavailableMsg = data.getAttribute('data-unavailable-msg');
    const url = data.getAttribute('data-url');

    detailsDescription.innerText =
      unavailableMsg !== '' ? unavailableMsg : description;
    detailsTitle.innerText = country;
    countryLinkButtons.forEach((countryLinkButton) => {
      countryLinkButton.href = url;
      const spanElement = countryLinkButton.querySelector('.visuallyhidden');
      spanElement.innerText = country;
    });

    servicesWrapper.classList.remove('hidden');
    employerOfRecordNode.classList.toggle('hidden', !employerOfRecord);
    payrollNode.classList.toggle('hidden', !payroll);
    contractorSolutionsNode.classList.toggle('hidden', !contractorSolutions);
    businessExpansionNode.classList.toggle('hidden', !businessExpansion);
    visaNode.classList.toggle('hidden', !visa);
    PMNode.classList.toggle('hidden', !PM);
    consultancyNode.classList.toggle('hidden', !consultancy);
    vasNode.classList.toggle('hidden', !vas);
    hrConsultancyNode.classList.toggle('hidden', !hrConsultancy);
    const servicesLeft = document.querySelectorAll(
      '.our-presence__details-card:not(.hidden)'
    ).length;
    if (servicesLeft === 0 && unavailableMsg === '') {
      detailsDescription.innerText =
        'No services currently available in this country.';
    }
  }

  // Event Listeners
  bannerSelect.addEventListener('change', displayCountryDetailsOnChange);

  getCountriesBtn.addEventListener('click', () => {
    addTabFocus();
    bannerSubmit.setAttribute('aria-pressed', 'true');
    detailsWrapper.setAttribute('aria-hidden', 'false');
    bannerWrapper.classList.add('banner-open');
  });
})();
